import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select, Space, Tag } from 'antd';
import { PageHeader } from '../../components/common/PageHeader';
import { DataTable } from '../../components/common/DataTable';
import { StatusBadge } from '../../components/common/StatusBadge';
import { useSubscriptionsList } from '../../hooks/useSubscriptions';
import { SUBSCRIPTION_STATUS_COLORS, PLAN_LABELS } from '../../lib/constants';
import dayjs from 'dayjs';
import type { AdminSubscriptionListItem } from '../../types/subscriptions';
import type { ColumnsType } from 'antd/es/table';

export function SubscriptionsListPage() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, per_page: 20, search: '', status: undefined as string | undefined, plan: undefined as string | undefined });
  const { data, isLoading } = useSubscriptionsList(params);

  const columns: ColumnsType<AdminSubscriptionListItem> = [
    { title: 'Organization', dataIndex: 'organization_name', key: 'org', render: (v: string, r) => <a onClick={() => navigate(`/subscriptions/${r.id}`)}>{v}</a> },
    { title: 'Owner', dataIndex: 'owner_email', key: 'owner' },
    { title: 'Plan', dataIndex: 'plan_id', key: 'plan', render: (v: string) => <Tag>{PLAN_LABELS[v] || v}</Tag> },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (v: string) => <StatusBadge status={v} colorMap={SUBSCRIPTION_STATUS_COLORS} /> },
    { title: 'Billing', dataIndex: 'billing_cycle', key: 'billing' },
    { title: 'Period End', dataIndex: 'current_period_end', key: 'period_end', render: (v: string | null) => v ? dayjs(v).format('MMM D, YYYY') : '-' },
    { title: 'Created', dataIndex: 'created_at', key: 'created', render: (v: string) => dayjs(v).format('MMM D, YYYY') },
  ];

  return (
    <>
      <PageHeader title="Subscriptions" subtitle={`${data?.total ?? 0} total`} />
      <DataTable<AdminSubscriptionListItem>
        columns={columns} dataSource={data?.data} loading={isLoading} total={data?.total} page={params.page} perPage={params.per_page}
        onPageChange={(p, ps) => setParams((s) => ({ ...s, page: p, per_page: ps }))}
        onSearch={(v) => setParams((s) => ({ ...s, search: v, page: 1 }))}
        extra={
          <Space>
            <Select placeholder="Status" allowClear style={{ width: 120 }} onChange={(v) => setParams((s) => ({ ...s, status: v, page: 1 }))} options={['active', 'trialing', 'past_due', 'canceled'].map((s) => ({ label: s, value: s }))} />
            <Select placeholder="Plan" allowClear style={{ width: 120 }} onChange={(v) => setParams((s) => ({ ...s, plan: v, page: 1 }))} options={['starter', 'growth', 'pro', 'business'].map((p) => ({ label: PLAN_LABELS[p], value: p }))} />
          </Space>
        }
      />
    </>
  );
}
